// extracted by mini-css-extract-plugin
export default {"root":"RealEstateView_root__RtZBm","banner":"RealEstateView_banner__aojkC","tapTarget":"RealEstateView_tapTarget__b9xya"};